// import { Transition } from "@headlessui/react";
// import InformationCircleIcon from "@heroicons/react/outline/InformationCircleIcon";
import { Product } from "@prisma/client";
import { useTranslation } from "next-i18next";
import { FC /* Fragment, useState */ } from "react";

type Props = Pick<Product, "numInStock">;

const OutOfStockComponent: FC<Props> = ({ numInStock }) => {
  // const [infoShow, setInfoShow] = useState(false);
  // const [persistInfo, setPersistInfo] = useState(false);
  const { t } = useTranslation("product", { keyPrefix: "out-of-stock" });

  return numInStock > 0 ? null : (
    <div className="w-full rounded tex-center mt-3 h-20 font-semibold pr-10">
      <div className="text-red-600">{t("text")}</div>
      <div className="text-black font-medium">
        {t("details")}
        {/* <Transition
          as={Fragment}
          show={persistInfo || infoShow}
          enter="transition duration-200 ease-out origin-bottom"
          enterFrom="scale-0 opacity-0"
          enterTo="scale-100 opacity-100"
          leave="transition duration-200 ease-in origin-bottom"
          leaveFrom="scale-100 opacity-100"
          leaveTo="scale-0 opacity-0"
        >
          <div className="absolute bottom-full w-56 left-1/2 -translate-x-1/2 ml-1">
            <span className="bg-black p-2 block rounded text-sm text-white">
              {t("details")}
            </span>
            <div className="w-4 h-4 rotate-45 bg-black mx-auto -mt-2" />
          </div>
        </Transition>
        <InformationCircleIcon
          className="w-4 inline -translate-y-px"
          onMouseEnter={() => setInfoShow(true)}
          onMouseLeave={() => setInfoShow(false)}
          onClick={() => setPersistInfo((old) => !old)}
        /> */}
      </div>
    </div>
  );
};

export default OutOfStockComponent;
